import { createApi } from "@reduxjs/toolkit/query/react";
import { IPaginationPayload } from "../../interfaces/shared/IPaginationPayload";
import reservationAxiosQuery from "../../utils/axios/reservation.axios";
import { PaginatedRoomRequests } from "../../interfaces/room-requests/paginatedRoomRequests.type";
import { ICompanyUsersProps } from "../../interfaces/company-user/ICompanyUsers";
import { PaginatedCompanyUsers } from "../../interfaces/company-user/paginatedUser.type";
import { ICompanyUsersRoles } from "../../interfaces/company-user/ICompanyUsersRoles";
import { AxiosResponse } from "axios";

export const companyUsersApi = createApi({
  reducerPath: "companyUsers",
  baseQuery: reservationAxiosQuery(),
  tagTypes: ["companyUsers"],
  endpoints: (builder) => ({
    getCompanyUsers: builder.query<PaginatedCompanyUsers, IPaginationPayload>({
      query: ({ filters, pageNumber, pageSize }: IPaginationPayload) => ({
        url: filters
          ? `/users?page=${pageNumber}&size=${pageSize}&filters=${filters}`
          : `/users?page=${pageNumber}&size=${pageSize}`,
        method: "GET",
      }),
    }),
    getCompanyUsersRoles: builder.query<AxiosResponse<ICompanyUsersRoles[]>, void>({
      query: () => ({
        url: `/roles/all`,
        method: "GET",
      }),
    }),
    postCompanyUser: builder.mutation<
      PaginatedRoomRequests,
      ICompanyUsersProps
    >({
      query: (data) => ({
        url: `/users`,
        method: "POST",
        data,
      }),
    }),
    editCompanyUser: builder.mutation<void, ICompanyUsersProps>({
      query: (data) => ({
        url: `/users/${data.id}`,
        method: "PUT",
        data: {},
      }),
    }),
    deleteCompanyUser: builder.mutation<void, string>({
      query: (id) => ({
        url: `/users/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetCompanyUsersQuery,
  useGetCompanyUsersRolesQuery,
  usePostCompanyUserMutation,
  useEditCompanyUserMutation,
  useDeleteCompanyUserMutation,
} = companyUsersApi;
